import { render, staticRenderFns } from "./rvh-maternity.vue?vue&type=template&id=05935f7c&"
import script from "./rvh-maternity.vue?vue&type=script&lang=js&"
export * from "./rvh-maternity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports